import { render, staticRenderFns } from "./AuditList.vue?vue&type=template&id=bb20ab26&scoped=true"
import script from "./AuditList.vue?vue&type=script&lang=js"
export * from "./AuditList.vue?vue&type=script&lang=js"
import style0 from "./AuditList.vue?vue&type=style&index=0&id=bb20ab26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb20ab26",
  null
  
)

export default component.exports